import React, { useMemo } from 'react';
import cuid from 'cuid';

interface GooglePlayProps {
  className?: string;
}

export const GooglePlay: React.FC<GooglePlayProps> = ({ className }) => {
  const id = useMemo(() => `google-play-${cuid()}`, []);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 216 62.44"
      className={className}
    >
      <defs>
        <linearGradient
          id={`${id}-google-linear-gradient`}
          x1="49.38"
          x2="10.5"
          y1="31.4"
          y2="31.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fee000" />
          <stop offset=".42" stopColor="#fbbc0e" />
          <stop offset=".78" stopColor="#f9a318" />
          <stop offset="1" stopColor="#f99b1c" />
        </linearGradient>
        <linearGradient
          id={`${id}-google-linear-gradient-2`}
          x1="39.29"
          x2="2.72"
          y1="35.09"
          y2="71.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ef4547" />
          <stop offset="1" stopColor="#c6186d" />
        </linearGradient>
        <linearGradient
          id={`${id}-google-linear-gradient-3`}
          x1="2.55"
          x2="32.42"
          y1="-9.02"
          y2="20.84"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#279e6f" />
          <stop offset=".04" stopColor="#2b9f6e" />
          <stop offset=".46" stopColor="#52b16b" />
          <stop offset=".8" stopColor="#6bbc69" />
          <stop offset="1" stopColor="#74c169" />
        </linearGradient>
      </defs>
      <rect width="216" height="62.44" rx="7.38" ry="7.38" />
      <path
        d="M108.97 34.22c-3.78 0-6.87 2.88-6.87 6.84s3.08 6.84 6.87 6.84 6.87-2.9 6.87-6.84-3.08-6.84-6.87-6.84Zm0 10.99c-2.07 0-3.86-1.71-3.86-4.15s1.79-4.15 3.86-4.15 3.86 1.68 3.86 4.15-1.79 4.15-3.86 4.15ZM93.99 34.22c-3.78 0-6.87 2.88-6.87 6.84s3.08 6.84 6.87 6.84 6.87-2.9 6.87-6.84-3.08-6.84-6.87-6.84Zm0 10.99c-2.07 0-3.86-1.71-3.86-4.15s1.79-4.15 3.86-4.15 3.86 1.68 3.86 4.15-1.79 4.15-3.86 4.15Zm-17.82-8.89v2.9h6.94a6.06 6.06 0 0 1-1.58 3.65 7.1 7.1 0 0 1-5.36 2.12c-4.28 0-7.62-3.45-7.62-7.72a7.62 7.62 0 0 1 12.85-5.65l2.05-2.05a10.12 10.12 0 0 0-7.28-2.93c-5.86 0-10.78 4.77-10.78 10.62s4.92 10.62 10.78 10.62c3.16 0 5.55-1.04 7.41-2.98 1.92-1.92 2.51-4.61 2.51-6.79 0-.67-.05-1.3-.16-1.81h-9.77Zm72.87 2.25c-.57-1.53-2.31-4.35-5.86-4.35s-6.45 2.77-6.45 6.84a6.7 6.7 0 0 0 6.79 6.84 6.8 6.8 0 0 0 5.7-3.03l-2.33-1.55c-.78 1.14-1.84 1.89-3.37 1.89s-2.62-.7-3.32-2.07l9.15-3.78-.31-.78Zm-9.33 2.28a3.75 3.75 0 0 1 3.58-3.99c1.19 0 2.2.6 2.54 1.45l-6.11 2.54Zm-7.44 6.63h3.01v-20.1h-3.01v20.11Zm-4.92-11.74h-.1a4.75 4.75 0 0 0-3.6-1.53c-3.42 0-6.56 3.01-6.56 6.87s3.14 6.81 6.56 6.81c1.63 0 2.93-.73 3.6-1.55h.1v.98c0 2.62-1.4 4.02-3.65 4.02a3.79 3.79 0 0 1-3.45-2.44l-2.62 1.09a6.52 6.52 0 0 0 6.06 4.04c3.52 0 6.5-2.07 6.5-7.13V34.62h-2.85v1.11Zm-3.45 9.46c-2.07 0-3.81-1.74-3.81-4.12s1.74-4.17 3.81-4.17 3.65 1.76 3.65 4.17-1.61 4.12-3.65 4.12Zm39.21-17.83h-7.19v20.11h3v-7.62h4.19c3.33 0 6.6-2.41 6.6-6.24s-3.27-6.24-6.6-6.24Zm.08 9.69h-4.27v-6.89h4.27c2.24 0 3.52 1.86 3.52 3.45s-1.27 3.45-3.52 3.45Zm18.55-2.89c-2.17 0-4.42.96-5.35 3.08l2.66 1.11c.57-1.11 1.63-1.47 2.74-1.47 1.55 0 3.13.93 3.16 2.59v.21a6.63 6.63 0 0 0-3.13-.78c-2.87 0-5.79 1.58-5.79 4.53 0 2.69 2.35 4.42 4.99 4.42 2.02 0 3.13-.91 3.83-1.97h.1v1.55h2.9v-7.71c0-3.57-2.66-5.56-6.1-5.56Zm-.36 11.02c-.98 0-2.35-.49-2.35-1.71 0-1.55 1.71-2.15 3.18-2.15 1.32 0 1.94.28 2.74.67a3.64 3.64 0 0 1-3.57 3.18Zm17.02-10.58-3.44 8.72h-.1l-3.57-8.72h-3.23l5.35 12.18-3.05 6.78h3.13l8.25-18.96h-3.34Zm-27.03 12.86h3V27.38h-3v20.11Z"
        fill="#fff"
      />
      <path
        fill="#5bc9f4"
        d="M16.16 11.38c-.47.49-.74 1.26-.74 2.26v35.53c0 1 .28 1.76.74 2.26l.12.12 19.91-19.91v-.47L16.28 11.26l-.12.12Z"
      />
      <path
        fill={`url(#${id}-google-linear-gradient)`}
        d="m42.83 38.28-6.64-6.64v-.47l6.64-6.64.15.09 7.86 4.47c2.25 1.28 2.25 3.36 0 4.64l-7.86 4.47-.15.09Z"
      />
      <path
        fill={`url(#${id}-google-linear-gradient-2)`}
        d="m42.98 38.19-6.79-6.79-20.03 20.03c.74.78 1.96.88 3.34.1l23.48-13.34"
      />
      <path
        fill={`url(#${id}-google-linear-gradient-3)`}
        d="M42.98 24.62 19.5 11.28c-1.38-.78-2.6-.69-3.34.1l20.03 20.03 6.79-6.79Z"
      />
      <g>
        <path
          d="M73.12 12.51a3.4 3.4 0 0 0-2.28-.88c-1.98 0-3.5 1.63-3.5 3.64s1.52 3.62 3.5 3.62c1.7 0 2.94-.99 3.02-2.55h-2.69v-1.11h4.15c0 3.32-1.77 4.89-4.48 4.89s-4.78-2.17-4.78-4.85 2.09-4.86 4.78-4.86c1.25 0 2.38.48 3.2 1.25l-.92.85Z"
          fill="#fff"
        />
        <path
          d="M82.66 10.52v1.19h-4.33v3.02h3.78v1.2h-3.78v2.86h4.46v1.19h-5.74v-9.46h5.6Z"
          fill="#fff"
        />
        <path
          d="M90.95 10.52v1.21h-2.87v8.25h-1.29v-8.25h-2.87v-1.21h7.03Z"
          fill="#fff"
        />
        <path d="M97.07 10.52v9.46h-1.28v-9.46h1.28Z" fill="#fff" />
        <path
          d="M105.78 10.52v1.21h-2.87v8.25h-1.29v-8.25h-2.87v-1.21h7.03Z"
          fill="#fff"
        />
        <path
          d="M114.79 10.41c2.71 0 4.81 2.17 4.81 4.86a4.79 4.79 0 1 1-9.59 0 4.8 4.8 0 0 1 4.78-4.86Zm0 8.47c1.99 0 3.52-1.61 3.52-3.61s-1.52-3.63-3.52-3.63-3.5 1.62-3.5 3.63 1.52 3.61 3.5 3.61Z"
          fill="#fff"
        />
        <path
          d="m127.15 19.98-4.31-7.13v7.13h-1.28v-9.46h1.26l4.27 7.07v-7.07h1.28v9.46h-1.22Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};
